import {Component, Inject, OnDestroy} from '@angular/core';
import {FormControl, Validators} from '@angular/forms';
import {BehaviorSubject, Subject, timer} from 'rxjs';
import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material/dialog';
import {HttpClient} from '@angular/common/http';

import { environment } from '../../../environments/environment';

@Component({
  selector: 'app-order-dialog',
  templateUrl: './order-dialog.component.html',
  styleUrls: ['./order-dialog.component.scss']
})
export class OrderDialogComponent implements OnDestroy {
  public busy$: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);
  public completed$: Subject<boolean> = new Subject<boolean>();
  public error$: Subject<any> = new Subject<any>();
  public unsubscribe$: Subject<void> = new Subject<void>();
  public showOrderTerms = false;
  public showOrderPrivacy = false;
  public userDidAgree = false;
  public fullname = new FormControl('', [
    Validators.required
  ]);
  public email = new FormControl('', [
    Validators.required,
    Validators.email
  ]);
  public phone = new FormControl('', [
    Validators.required
  ]);
  public address = new FormControl('', [
    Validators.required
  ]);
  public address2 = new FormControl('', [
    Validators.required
  ]);
  public country = new FormControl('', [
    Validators.required
  ]);
  private configurationId: string;
  private reloadPage$: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);

  constructor(public dialogRef: MatDialogRef<OrderDialogComponent>,
              @Inject(MAT_DIALOG_DATA) public dialogData: { twikbot: any, exportDescriptorUrl: string }, private http: HttpClient) {
  }

  public generateUniqueId(length) {
    const result: Array<string> = [];
    const characters = 'ABCDEFGHIJKMNOPQSTUVWXYZ0123456789';
    for (let i = 0; i < length; i++) {
      result.push(characters.charAt(Math.floor(Math.random() * characters.length)));
    }
    return result.join('');
  }

  public order() {

    if (this.email.valid && this.phone.valid && this.fullname.valid && this.address.valid && this.address2.valid && this.country.valid) {
      const uniqueId = this.generateUniqueId(8);

      this.error$.next(null);
      this.completed$.next(false);
      this.busy$.next(true);
      this.dialogData.twikbot.setValue('14-unique_id', uniqueId);
      this.dialogData.twikbot.saveConfigurator().then((savedConfiguration) => {
        this.sendOrderToOrderService(savedConfiguration, uniqueId);
      });

    } else {
      console.log('it is not valid');
    }
  }

  onNoClick() {
    this.dialogRef.close();
  }

  ngOnDestroy(): void {
    this.unsubscribe$.next();
    this.unsubscribe$.complete();
  }

  public closeDialog(reload: boolean = false) {
    if (this.reloadPage$.getValue()) {
      window.location.reload();
    } else {
      this.dialogRef.close();
    }
  }

  private sendOrderToOrderService(savedConfiguration, uniqueId) {
    this.http.get(`${environment.configurationsUrl}/api/v1/configurations/${savedConfiguration.configurationId}`)
      .subscribe((config: any) => {

        const orderCreateDTO = {
          order: {
            spaceKey: environment.spaceKey,
            flowKey: environment.flowKey,
            thirdPartyOrderId: uniqueId,
            updateUrl: null,
            addresses: [],
            data: {},
            customerInfo: {
              name: this.fullname.value,
              email: this.email.value,
              phone: this.phone.value,
              message: `${this.address.value} ${this.address2.value}, ${this.country.value}`
            },
            orderLines: [{
              data: {
                twikbotVersion: config.twikbotVersion,
                productUrl: this.dialogData.exportDescriptorUrl, // TODO
                parameters: JSON.parse(config.configurationJson).parameters,
                resources: JSON.parse(config.configurationJson).resources
              },
              title: uniqueId,
              amountOfUnits: 1,
              items: [{
                tags: ['preview_image'],
                data: {},
                items: [],
                id: 'Handle Bar',
                assets: [
                  {
                    url: savedConfiguration.previewUrl
                  }
                ]
              }],
              valuePerUnit: 0
            }]
          }
        };
        this.http.post(`${environment.orderServiceUrl}/api/order/create`, orderCreateDTO).subscribe((response) => {
          this.completed$.next(true);
          this.reloadPage$.next(true);
          // await order
          this.busy$.next(false);
          setTimeout(() => this.closeDialog(), 5000);
        });
      });
  }
}
